export const renderTruncateText = (text: string, maxTextLength: number = 200) => {
  return {
    truncatedText: text.length > maxTextLength ? `${text.slice(0, maxTextLength)}...` : text,
    isTruncated: text.length > maxTextLength,
  };
};
